import { IDriverAutocomplete } from 'features/Drivers/components/MultiDriverAutocomplete'
import { GTRouteServiceScheduleFrequencyUnit, GTTVehicleAutocomplete } from 'gql/types.generated'

export interface IVehiclesCardProps {
  companyId: string
  currentServiceIndex: number
  formDisabled?: boolean
}

export interface IVehicleFrequency {
  value: number
  unit: GTRouteServiceScheduleFrequencyUnit
}

export enum EVehicleScheduleType {
  Dow = 'DOW',
  Frequency = 'FREQUENCY'
}

export interface IVehicle {
  id?: string
  vehicle: Partial<GTTVehicleAutocomplete>
  startDate?: Date
  expirationDate?: Date
  operationDays: number[]
  frequency: IVehicleFrequency
  type: EVehicleScheduleType
  driver: IDriverAutocomplete
}

export interface IVehiclesForm {
  vehicles: IVehicle[]
}
